import React from 'react';
import { AuthContext } from 'Components/utils/AuthContext';

const useAuth = () => React.useContext(AuthContext);

export default useAuth;
